// src/environments/environment.ts
import { Environment } from './environment.model';
export const environment: Environment = {
    production: false,
    stage: 'PREP',
    region: 'EMEA',
    apiBaseUrls: {
        EMEA: 'https://huutlh2v2a.execute-api.eu-west-1.amazonaws.com/fcl/v1'
    },
    cognitoConfigs: {
        EMEA: {
            aws_project_region: 'eu-west-1',
            aws_cognito_region: 'eu-west-1',
            aws_user_pools_id: 'eu-west-1_eNXWxnsMm',
            aws_user_pools_web_client_id: '4shnok4i3kldjpe9dff5n41sc8'
        }
    },
    zuoraEntity: ['EMEA', 'MAS_EMEA', 'IAP', 'MAS_IAP']
};